import React from "react";
import { List, Datagrid, TextField, EditButton } from "admin-on-rest";
// import find from "lodash.find";
import IconTitle from "../components/icon_title";
import Pagination from "../components/pagination";
import { PaymentFilter, PaymentActions } from "./defaultValues";
import { ROLE_ADMIN } from "../App";

const ActiveField = ({ record = {} }) => {
  const text = record.active ? "Active" : "Inactive";
  return <span>{text}</span>;
};
ActiveField.defaultProps = { label: "Active" };

export const PaymentModeList = props => (
  <List
    {...props}
    actions={<PaymentActions />}
    title={
      <IconTitle icon="payments" title={"resources.paymentmode.titleHeader"} />
    }
    sort={{ field: "created_at", order: "DESC" }}
    filters={<PaymentFilter />}
    perPage={10}
    pagination={<Pagination />}
  >
    {permissions => (
      <Datagrid bodyOptions={{ showRowHover: true }}>
        <TextField label="resources.paymentmode.field.name" source="name" />
        <ActiveField
          label="resources.paymentmode.field.active"
          source="active"
        />

        {permissions === ROLE_ADMIN && (
          <EditButton label="" style={{ textAlign: "right" }} />
        )}
      </Datagrid>
    )}
  </List>
);



// WEBPACK FOOTER //
// ./src/paymentmode/List.js